// The turn-end summary lands on the turn's posts already on screen (message_work_updated).
import type { Message, WorkSummary } from "./core/types.js";

export function patchWorkSummary(
  messages: Message[],
  messageIds: readonly string[],
  work: WorkSummary,
): Message[] {
  const ids = new Set(messageIds);
  return messages.map((m) => (ids.has(m.id) ? { ...m, workSummary: work } : m));
}

// Reload delta: a painted row takes the summary stamped after it was cached.
export function mergeDeltaRows(painted: Message[], delta: Message[]): Message[] {
  const fresh = new Map(delta.map((m) => [m.id, m]));
  const held = new Set(painted.map((m) => m.id));
  const patched = painted.map((m) => {
    const work = fresh.get(m.id)?.workSummary;
    return work ? { ...m, workSummary: work } : m;
  });
  return [...patched, ...delta.filter((m) => !held.has(m.id))];
}
